import Breakpoints from 'breakpoints-js/src/breakpoints';
import pdpSliderGallery from './rbata.pdpSliderGallery';
import startCloudinaryResponsive from '../utils/rbata.cloudinary';

const imagePanel = {
    sliderSelector:          '#js-pdp__image-panel',
    $sliderContainer:        undefined,
    $sliderNavigation:       undefined,
    $sliderCounter:          undefined,
    slider:                  null,
    suppressedVideoSelector: '.pdp__image-panel-wrapper--hero-video .pdp__gallery-slide:first-child:has(.pdp__gallery-video)',
    suppressedVideo:         undefined,
    suppressedVideoCloned:   undefined,
    buildSlider() {
        this.$sliderContainer  = $(this.sliderSelector);
        this.$sliderNavigation = this.$sliderContainer.next('nav');
        this.$sliderCounter    = $('.js-image-panel__counter');
        this.slider            = tns({
            container:         this.sliderSelector,
            mode:              'carousel',
            items:             1,
            controls:          true,
            controlsContainer: this.$sliderNavigation[0],
            nav:               false,
            arrowKeys:         true,
            speed:             300,
            lazyload:          false,
            mouseDrag:         false,
            onInit:            () => {
                this.$sliderContainer.removeClass('pdp__image-panel--not-initialized');
                startCloudinaryResponsive();
            },
        });
        this.slider.events.on('indexChanged', (data) => {
            const {displayIndex, slideCount} = data;
            this.updateCounter(displayIndex, slideCount);
        });
        const {displayIndex, slideCount} = this.slider.getInfo();
        this.updateCounter(displayIndex, slideCount)
    },

    updateCounter(displayIndex, slideCount) {
        this.$sliderCounter.html(`${displayIndex}&nbsp;/&nbsp;${slideCount}`);
    },

    destroySlider() {
        if (this.slider && typeof (this.slider.destroy) === typeof (Function)) {
            this.slider.destroy();
        }
        startCloudinaryResponsive();
    },
    rebuildSlider() {
        if (!Breakpoints.is('desktop')) {
            imagePanel.buildSlider();
        }
    },
    bindHandler() {
        Breakpoints.on('mobile tablet', {
            enter: () => {
                if (!$(this.suppressedVideoSelector).length && this.suppressedVideoCloned) {
                    $(this.sliderSelector).prepend(this.suppressedVideoCloned).find('.pdp__gallery-video')[0].play();
                }
                pdpSliderGallery.extractImageSources();
                imagePanel.buildSlider();
            },
            leave: () => {
                imagePanel.destroySlider();
                this.suppressedVideo = $(this.suppressedVideoSelector);
                if (this.suppressedVideo.length) {
                    this.suppressedVideo.remove();
                }

            }
        });
    },
    init() {
        // Special handling if a hero video is maintained:
        // For desktop view don't show first gallery media if it's a video
        this.suppressedVideo = $(this.suppressedVideoSelector);
        if (this.suppressedVideo.length) {
            this.suppressedVideoCloned = this.suppressedVideo.clone();
            if (Breakpoints.is('desktop')) {
                this.suppressedVideo.remove();
            }
        }

    },
    animate() {
        const downUpAnimation = document.querySelector('.pdp__wrapper--hero');
        if (downUpAnimation) {
            // https://matthewlein.com/tools/ceaser
            downUpAnimation.animate(
                    [
                        {transform: 'translate3D(0, 0, 0)'},
                        {transform: 'translate3D(0, -120px, 0)'},
                        {transform: 'translate3D(0, 0, 0)'},
                    ], {
                        delay:    500,
                        duration: 1200,
                        easing:   'cubic-bezier(0.35, 0.9, 0.65, 0.1)',
                    }
            ).onfinish = () => {
                sessionStorage.setItem('pdpMicroAnimationDone', 'true');
            }
        }
    }
};

// DOM ready
$(() => {
    if (document.querySelector(imagePanel.sliderSelector)) {
        imagePanel.init();
        imagePanel.bindHandler();
        if (Breakpoints.is('desktop') && !sessionStorage.getItem('pdpMicroAnimationDone')) {
            imagePanel.animate();
        }
    }
});

export default imagePanel;
